import {Component, ElementRef, EventEmitter, ViewChild, Output} from '@angular/core';
import {DeliveryService} from "../../../../services/delivery.service";
import {Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {LocalStorageService} from "../../../../services/local-storage.service";
import {
  MessageDeliveryConfirmComponent
} from "../../messages/message-delivery-confirm/message-delivery-confirm.component";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-delivery-targeted',
  templateUrl: './delivery-targeted.component.html',
  styleUrls: ['../../../basket-confirm/basket-confirm.component.scss']
})
export class DeliveryTargetedComponent extends DeliveryService {
  @ViewChild('phoneRef') override phoneRef: ElementRef<HTMLInputElement>;
  @ViewChild('scrollInputRef') scrollInputRef: ElementRef<HTMLInputElement>;
  @ViewChild(MessageDeliveryConfirmComponent) messageDeliveryConfirmComponentRef: MessageDeliveryConfirmComponent;

  @Output() selectedDeliveryType = new EventEmitter<number>();

  wrongDeliveryTargetAddress = false;
  private isUserChangedDeliveryDate = false;
  public addressSuggestions: { text: string; placeId: string; types?: string[] }[] = [];
  public isAddressSuggestionsOpen = false;
  private timeAddressSuggest;
  // Номер останнього запиту підказок: пізня відповідь на старіший запит (або вже після
  // вибору адреси) знову відкривала б список зі старою адресою
  private addressSuggestSeq = 0;
  public closeSuggestionsList = false;

  constructor(
    http: HttpClient,
    localStorage: LocalStorageService,
    private router: Router
  ) {
    super(http, localStorage);
  }

  searchAddressSuggestions(queryAddress: string) {
    const query = (queryAddress || '').trim();

    clearTimeout(this.timeAddressSuggest);
    const seq = ++this.addressSuggestSeq;

    this.timeAddressSuggest = setTimeout(() => {
    this.http.post<any>(this.apiRoot + 'geo/autocomplete', {
      search: query
    })
      .pipe(takeUntil(this.isDestroyed))
      .subscribe(data => {
        if (seq !== this.addressSuggestSeq) {
          return;
        }

        this.addressSuggestions = [];
        let suggestions = [];

        if (data && data.data && Array.isArray(data.data.suggestions)) {
          suggestions = data.data.suggestions;
        } else {
          suggestions = [];
        }

        for (const suggestion of suggestions) {
          this.addressSuggestions.push({
            text: suggestion.text,
            placeId: suggestion.placeId,
            types: suggestion.types,
          });
        }

        this.isAddressSuggestionsOpen = !this.closeSuggestionsList && this.addressSuggestions.length > 0;
      })
    }, 500);
  }

  searchAddressInput(value: string) {
    this.closeSuggestionsList = false;

    this.inputDeliveryCityValidation();

    if (this.delivery !== 1) {
      this.cancelAddressSuggestions();
      this.isAddressSuggestionsOpen = false;
      this.addressSuggestions = [];
      this.selectedPlaceId = null;
      return;
    }

    // place_id (координати і сектор кур'єра на беку) належить вибраній адресі. Дописувати до неї
    // можна (підказки без номера будинку), а якщо з неї щось стерли/замінили - це вже інша адреса.
    if (this.selectedPlaceId && !this.isAddressExtended(this.selectedPlaceAddress, value)) {
      this.selectedPlaceId = null;
      this.selectedPlaceAddress = null;
    }

    this.searchAddressSuggestions(value);
  }

  // Чи всі символи вибраної адреси залишились у тексті в тому ж порядку (лише дописали).
  private isAddressExtended(placeAddress: string | null, value: string): boolean {
    if (!placeAddress || !value) {
      return false;
    }

    let i = 0;
    for (let j = 0; j < value.length && i < placeAddress.length; j++) {
      if (value[j] === placeAddress[i]) {
        i++;
      }
    }

    return i === placeAddress.length;
  }

  selectAddressSuggestion(s: { text: string; placeId: string }) {
    this.lastAddress.city = s.text;
    this.selectedPlaceId = s.placeId;
    this.selectedPlaceAddress = s.text;

    this.cancelAddressSuggestions();
    this.isAddressSuggestionsOpen = false;
    this.addressSuggestions = [];

    this.inputDeliveryCityValidation();
  }

  // Адресу вибрано / список закрито: таймер і запит, що ще в дорозі, вже не потрібні
  private cancelAddressSuggestions() {
    clearTimeout(this.timeAddressSuggest);
    this.addressSuggestSeq++;
  }

  closeSuggestions() {
    this.cancelAddressSuggestions();
    this.closeSuggestionsList = true;
    this.isAddressSuggestionsOpen = false;
    this.addressSuggestions = [];
  }

  override scrollToInvalidForm() {
    if (this.wrongDeliveryTargetAddress) {
      this.scrollInputRef.nativeElement.scrollIntoView();
    }
  }

  inputDeliveryCityValidation() {
    if (this.delivery === 1) {
      if (this.lastAddress.city === null || this.lastAddress.city.length < 4) {
        this.wrongDeliveryTargetAddress = true;
        this.isValidDeliveryForm = true;
      } else {
        this.wrongDeliveryTargetAddress = false;
      }
    } else {
      if (this.lastAddress.city === null || this.lastAddress.city.length < 10) {
        this.wrongDeliveryTargetAddress = true;
        this.isValidDeliveryForm = true;
      } else {
        this.wrongDeliveryTargetAddress = false;
      }
    }
  }

  crossClearAddress() {
    this.lastAddress.city = '';
    this.selectedPlaceId = null;
    this.selectedPlaceAddress = null;
    this.addressSuggestions = [];
    this.isAddressSuggestionsOpen = false;
    this.inputDeliveryCityValidation();
  }

  onUserChangeDeliveryDate() {
    this.isUserChangedDeliveryDate = true;
    this.changingValueDeliveryDate();
  }

  changingValueDeliveryDate() {
    if (this.deliveryDate == -1 && !this.dozakazDate) {
      this.wrongDeliveryDates = true;
      this.isValidDeliveryForm = true;
    } else {
      this.wrongDeliveryDates = false;
    }

    if (this.deliveryDate != -1 && this.deliveryCurrent && this.deliveryCurrent.delivery_hours && this.deliveryCurrent.delivery_hours[this.deliveryDate]) {
      this.deliveryHoursList = this.deliveryCurrent.delivery_hours[this.deliveryDate];
    } else {
      this.deliveryHoursList = [];
    }

    if (this.isUserChangedDeliveryDate) {
      this.deliveryHours = -1;
      this.wrongDeliveryHours = false;
      this.isUserChangedDeliveryDate = false;
    }
  }

  changingValueDeliveryHours() {
    if (!this.deliveryHoursList?.length) {
      this.wrongDeliveryHours = false;
      return;
    }

    if (this.deliveryHours == -1 && !this.dozakazDate) {
      this.wrongDeliveryHours = true;
      this.isValidDeliveryForm = true;
    } else {
      this.wrongDeliveryHours = false;
    }
  }

  switchesDeliveryType(id: number) {
    this.selectedDeliveryType.emit(id);
  }

  override validateSendPayment() {
    this.isValidDeliveryForm = false;
    const sendData = {
      delivery_id: this.delivery
    };

    this.inputDeliveryCityValidation();
    this.changingValueDeliveryDate();
    this.changingValueDeliveryHours();
    this.inputLastAddressPhone();

    sendData['address'] = this.lastAddress.city;

    if (this.selectedPlaceId) {
      sendData['place_id'] = this.selectedPlaceId;
    }

    sendData['delivery_date'] = this.deliveryDate;

    sendData['delivery_hour'] = '';

    if (this.deliveryHoursList?.length && this.deliveryHours !== -1) {
      sendData['delivery_hour'] = this.deliveryHours;
    }

    if (this.dozakazDate) {
      sendData['delivery_date'] = this.dozakazDate;
    }
    sendData['comment'] = this.deliveryComment;
    sendData['phone'] = this.phoneRef.nativeElement.value.replace(/\+38/g, '').replace(/\D/g, '');

    // Дати переміщення бек рахує лише по підзамовних товарах: для кошика зі складів 1+7 без них список
    // порожній, а вибір обов'язковий - форма не відправлялась. Без delivery_date_zak бек бере delivery_date.
    if (this.separateOrders && this.deliveryCurrent?.delivery_dates_zak?.length) {
      this.changingValueDeliverySeparate();

      sendData['delivery_date_zak'] = this.deliverySeparate;
    }

    return sendData;
  }

  override resultSendPayment(data) {
    if (data.error === '' && data.data.order_id) {
      data.data.delivery = this.delivery;
      this.isDeliveryConfirmation = true;
      this.messageDeliveryConfirmComponentRef.deliveryConfirmationShow(data, this.user);
    }

    if (data.error === 'empty basket') {
      this.router.navigate(['account']);
    }

    if (data.error === 'too many orders') {
      this.router.navigate(['account']);
    }

    if (data.error === 'not_enough_liters') {
      this.router.navigate(['basket']);
    }
  }
}
